import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const cells = [
    { name: "Internal Quality Assurance Cell (IQAC)", link: "#" },
    { name: "Publication Cell", link: "#" },
    { name: "Right to Information Cell (RTI)", link: "#" },
    { name: "Placement Cell", link: "#" },
    { name: "Grievance Redressal Cell", link: "#" },
    { name: "Anti-Ragging Cell", link: "#" },
    { name: "Sexual Harassment Prevention Cell", link: "#" },
    { name: "National Academic Depository (NAD)", link: "#" },
    { name: "National Education Policy (NEP)", link: "#" },
    { name: "Public Relations Officer (PRO)", link: "#" },
    { name: "Guidance & Counselling Cell", link: "#" },
];

const committees = [

    { name: "Registration Committee", link: "#" },
    { name: "Time Table Committee", link: "#" },
    { name: "Unfair Means Committee", link: "#" },
    { name: "Cultural Committee", link: "#" },
    { name: "Scholarship Committee", link: "#" },
    { name: "Library Committee", link: "#" },
    { name: "Games & Sports Committee", link: "#" },
    { name: "MOU Committee", link: "#" },
    { name: "Hostel Committee", link: "#" },
    { name: "Teacher & Guardian Interaction Committee", link: "#" },
    { name: "NCC & NSS Committee", link: "#" },
    { name: "Student Welfare Committee", link: "#" },
    { name: "Vigilance Committee", link: "#" }, // Correctly placed in Committees
];


const allDepartments = [...cells, ...committees];


const iqacMembers = [
    { id: 1, name: "Director, Internal Quality Assurance Cell (IQAC)", role: "Chairperson" },
    { id: 2, name: "Dean Academic, M.V.S.V., Kaithal", role: "Member" },
    { id: 3, name: "Dean Faculty of Literature & Culture, M.V.S.V., Kaithal", role: "Member" },
    { id: 4, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal", role: "Member" },
    { id: 5, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal", role: "Member" },
    { id: 6, name: "Dr. Naveen Sharma, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 7, name: "Dr. Chandra Kant, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 8, name: "Dr. Govind Ballabh, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 9, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 10, name: "Shri Amardeep, D.E.O. (HKRN), M.V.S.V., Kaithal", role: "" },
];

const publicationMembers = [
    { id: 1, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal", role: "Chairperson" },
    { id: 2, name: "Dr. Krishna Chandra Pandey, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 3, name: "Dr. Naveen Sharma, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 4, name: "Dr. Chandra Kant, Assistant Professor (Contract), M.V.S.V., Kaithal", role: "Member" },
    { id: 5, name: "Shri Mukesh Kumar, Clerk (HKRN), M.V.S.V., Kaithal", role: "" },
];

const rtiMembers = [
    { id: 1, name: "Registrar, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Superintendent (Finance), M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Shri Ankur, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const placementMembers = [
    { id: 1, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Shri Mukesh Kumar, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" }
];

const grievanceMembers = [
    { id: 1, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Jagat Narayan Kaushik, Associate Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Prof. (Dr.) Rosy Gupta, Dr. B.R. Ambedkar Government College, Kaithal.", role: "Member" },
    { id: 4, name: "Shri Subhash Chand, Superintendent (Administration), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Ms. Sandeepi, Assistant Professor (Computer Science), Dr. B.R. Ambedkar Government College, Kaithal.", role: "Member" },
    { id: 6, name: "Ms. Neelam, Research Scholar (Department of Literature)", role: "Member" },
    { id: 7, name: "Ms. Kusum, Student (Acharya - First Year)", role: "Member" },
    { id: 8, name: "Smt. Anita, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "Member" }
];

const disciplineCommitteeMembers = [
    { id: 1, name: "Dr. Jagat Narayan Kaushik, Associate Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Shri Tarsem, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "Member" }
];

const antiRaggingMembers = [
    { id: 1, name: "Chief Proctor", role: "Chairperson" },
    { id: 2, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" }
];

const proMembers = [
    { id: 1, name: "Dr. Govind Ballabh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Shri Mukesh Kumar, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" }
];

const registrationCommittee = [
    { id: 1, name: "Dean Academic, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Jagat Narayan Kaushik, Associate Professor, M.V.S.V., Kaithal.", role: "Co-Chairperson" },
    { id: 3, name: "Dr. Surendra Pal Vats, Associate Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Dr. Naresh Sharma, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 6, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 7, name: "Dr. Krishna Chandra Pandey, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 8, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 9, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 10, name: "Dr. Kuldeep Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "" },
    { id: 11, name: "Shri Praveen Kumar, Assistant (Deputation), M.V.S.V., Kaithal.", role: "" },
    { id: 12, name: "Shri Ramesh, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
    { id: 13, name: "Shri Sahil, Fees Clerk (HKRN), M.V.S.V., Kaithal.", role: "" }
];

const TimetableCommittee = [
    { id: 1, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Co-Chairperson" },
    { id: 3, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Dr. Chandra Kant, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 6, name: "Shri Sita Ram, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const UnfairCommittee = [
    { id: 1, name: "Controller of Examinations, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Surendra Pal Vats, Associate Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Subject Expert", role: "Member" },
];

const CulturalCommittee = [
    { id: 1, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Naveen Sharma, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Harish Kumar, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Rajiv Sharma, Assistant Professor (Part-time), M.V.S.V., Kaithal.", role: "Member" },
    { id: 6, name: "Shri Sita Ram, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const ScholarshipCommittee = [
    { id: 1, name: "Dr. Surendra Pal Vats, Associate Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Krishna Chandra Pandey, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Shri Sikandar Lal, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const LibraryCommittee = [
    { id: 1, name: "Dean Academic, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Jagat Narayan Kaushik, Head of Department (Literature).", role: "Co-Chairperson" },
    { id: 3, name: "Dr. Surendra Pal Vats, Head of Department (Grammar).", role: "Member" },
    { id: 4, name: "Dr. Naresh Sharma, Head of Department (Jyotish), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Dr. Akhilesh Kumar Mishra, Head of Department (Veda), M.V.S.V., Kaithal.", role: "Member" },
    { id: 6, name: "Dr. Krishna Chandra Pandey, Head of Department (Hindu Studies), M.V.S.V., Kaithal.", role: "Member" },
    { id: 7, name: "Dr. Devendra Singh, In-charge (Yoga), M.V.S.V., Kaithal.", role: "Member" },
    { id: 8, name: "Dr. Vinay Gopal Tripathi, In-charge (Philosophy), M.V.S.V., Kaithal.", role: "Member" },
    { id: 9, name: "Dr. Kuldeep Singh, In-charge (Dharmashastra), M.V.S.V., Kaithal.", role: "Member" },
    { id: 10, name: "Shri Kulwant Singh, Clerk (HKRN), M.V.S.V., Kaithal.", role: "Member" },
];

const GamesAndSportsCommittee = [
    { id: 1, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Kuldeep Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 3, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Shri Sikandar Lal, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const MOUMemoraCommittee = [
    { id: 1, name: "Dr. Surendra Pal Vats, Associate Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Krishna Chandra Pandey, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 3, name: "Dr. Harish Kumar, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Shri Mahavir, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const DisciplineCommittee = [
    { id: 1, name: "Dr. Jagat Narayan Kaushik, Associate Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Shri Tarsem, D.E.O. (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const HostelCommittee = [
    { id: 1, name: "Dean Academic, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Shri Ramesh, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const TeacherGuardianInteractionCommittee = [
    { id: 1, name: "Dr. Krishna Chandra Pandey, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Harish Kumar, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Devendra Singh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Govind Ballabh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
];

const StudentWelfareCommitteeMembers = [
    { id: 1, name: "Dean Academic, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Naresh Sharma, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Sharmila, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Dr. Chandra Kant, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 6, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 7, name: "Shri Ramesh, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const NCCAndNSSCommittee = [
    { id: 1, name: "Dr. Naresh Sharma, Assistant Professor, M.V.S.V., Kaithal.", role: "NSS Chairperson" },
    { id: 2, name: "Dr. Vinay Gopal Tripathi, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "NCC Chairperson" },
    { id: 3, name: "Dr. Chandra Kant, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Govind Ballabh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 5, name: "Shri Sita Ram, Clerk (HKRN), M.V.S.V., Kaithal.", role: "" },
];

const VigilanceCommitteeMembers = [
    { id: 1, name: "Finance Officer, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Deputy Registrar, M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Akhilesh Kumar Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Member" },
];

const GuidanceAndCounsellingCell = [
    { id: 1, name: "Dr. Ramanand Mishra, Assistant Professor, M.V.S.V., Kaithal.", role: "Chairperson" },
    { id: 2, name: "Dr. Naveen Sharma, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 3, name: "Dr. Harish Kumar, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
    { id: 4, name: "Dr. Govind Ballabh, Assistant Professor (Contract), M.V.S.V., Kaithal.", role: "Member" },
];


// Mapping of department/committee names to their respective member data
const membersMap = {
    "Internal Quality Assurance Cell (IQAC)": iqacMembers,
    "Publication Cell": publicationMembers,
    "Right to Information Cell (RTI)": rtiMembers,
    "Placement Cell": placementMembers,
    "Grievance Redressal Cell": grievanceMembers,
    "Discipline Committee": disciplineCommitteeMembers,
    "Anti-Ragging Cell": antiRaggingMembers,
    "Public Relations Officer (PRO)": proMembers,
    "Registration Committee": registrationCommittee,
    "Time Table Committee": TimetableCommittee,
    "Unfair Means Committee": UnfairCommittee,
    "Cultural Committee": CulturalCommittee,
    "Scholarship Committee": ScholarshipCommittee,
    "Library Committee": LibraryCommittee,
    "Games & Sports Committee": GamesAndSportsCommittee,
    "MOU Committee": MOUMemoraCommittee,
    "Hostel Committee": HostelCommittee,
    "Teacher & Guardian Interaction Committee": TeacherGuardianInteractionCommittee,
    "Student Welfare Committee": StudentWelfareCommitteeMembers, // Corrected name
    "NCC & NSS Committee": NCCAndNSSCommittee,
    "Vigilance Committee": VigilanceCommitteeMembers, // Corrected name
    "Guidance & Counselling Cell": GuidanceAndCounsellingCell,
    // Add placeholders for departments/committees without provided member data
    "Sexual Harassment Prevention Cell": [],
    "National Academic Depository (NAD)": [],
    "National Education Policy (NEP)": [],
};


export default function SpecialCellsCommittees_Eng() {

    const [showSidebar, setShowSidebar] = useState(window.innerWidth >= 768);

    // Initial content set to the first item in the 'cells' list
    const [content, setContent] = useState(cells[0].name);

    // Collapsible states for Cells and Committees
    const [showCells, setShowCells] = useState(true);
    const [showCommittees, setShowCommittees] = useState(true);


    useEffect(() => {
        const handleResize = () => {
            setShowSidebar(window.innerWidth >= 768);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleItemClick = (deptName) => {
        setContent(deptName);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };


    const membersToDisplay = membersMap[content];

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            <div className="d-md-none sticky-top bg-primary p-2 shadow-sm d-flex justify-content-between align-items-center">
                <button
                    className="btn d-md-none m-2 shadow-sm text-white"
                    onClick={() => setShowSidebar(!showSidebar)}
                    style={{
                        backgroundColor: "#77236b",
                        borderColor: "#77236b"
                    }}
                >
                    ☰ Menu
                </button>


                <h5 className="text-white my-0">Special Cells & Committees</h5>
            </div>


            <aside
                className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"
                    } col-md-3 bg-white`}
                style={{ overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 d-none d-md-block text-dark">Special Cells & Committees</h5>
                <div className="flex-grow-1">

                    {/* Cells Section - Collapsible */}
                    <div className="card mt-3">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => setShowCells(!showCells)}
                            style={{ cursor: "pointer", backgroundColor: '#77236b', color: '#fff', fontWeight: 'bold' }}
                        >
                            Cells
                            <span className="fs-5">
                                {showCells ? '−' : '+'}
                            </span>
                        </div>
                        <div className={`collapse ${showCells ? 'show' : ''}`} id="cellsCollapse">
                            <div className="card-body p-0">
                                {cells.map((dept, index) => (
                                    <p
                                        key={`cell-${index}`}
                                        className={`mb-0 p-3 border-bottom rounded-0 ${content === dept.name
                                            ? "text-white"
                                            : "text-dark"
                                            }`}
                                        onClick={() => handleItemClick(dept.name)}
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "0.95rem",
                                            backgroundColor: content === dept.name ? "#77236b" : "#f8f9fa"
                                        }}
                                    >
                                        {dept.name}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>


                    {/* Committees Section - Collapsible */}
                    <div className="card mt-3">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => setShowCommittees(!showCommittees)}
                            style={{ cursor: "pointer", backgroundColor: '#77236b', color: '#fff', fontWeight: 'bold' }}
                        >
                            Committees
                            <span className="fs-5">
                                {showCommittees ? '−' : '+'}
                            </span>
                        </div>
                        <div className={`collapse ${showCommittees ? 'show' : ''}`} id="committeesCollapse">
                            <div className="card-body p-0">
                                {committees.map((dept, index) => (
                                    <p
                                        key={`committee-${index}`}
                                        className={`mb-0 p-3 border-bottom rounded-0 ${content === dept.name
                                            ? "text-white"
                                            : "text-dark"
                                            }`}
                                        onClick={() => handleItemClick(dept.name)}
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "0.95rem",
                                            backgroundColor: content === dept.name ? "#77236b" : "#f8f9fa"
                                        }}
                                    >
                                        {dept.name}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </aside>


            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 d-flex flex-column"
                style={{ overflowY: 'auto' }}
            >
                {content ? (
                    <>
                        {membersToDisplay && membersToDisplay.length > 0 ? (
                            <div className="table-responsive flex-grow-1">
                                <h6 className="mb-3 text-center fw-bold" style={{ color: "#77236b" }}>
                                    {`Members of ${content}`}
                                </h6>
                                <table className="table table-bordered table-striped table-hover mt-3">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {membersToDisplay.map((member) => (
                                            <tr key={member.id}>
                                                <td>{member.id}</td>
                                                <td>{member.name}</td>
                                                <td>{member.role}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p className="text-center mt-5 fs-5 text-muted">No member data available for this section.</p>
                        )}
                    </>
                ) : (
                    <p className="text-center mt-5 fs-5 text-muted">Please select a section from the menu on the left.</p>
                )}
            </main>
        </div>
    );
}